import { Box, Group } from '@mantine/core';
import { FaultRow } from 'components/tables/data/fault/types';
import { BadgeFixed } from 'components/Badge';
import P2Medium from 'components/typography/P2Medium';
import Excerpt from 'components/Excerpt';
import FileThumbnail from 'components/files/FileThumbnail';
import { useState } from 'react';
import Slider from 'components/modals/slider/Slider';
import { FEATURE_TOGGLE_DEVICE_IMAGES_SLIDER } from 'env';

/**
 * Displays the first image of the fault and opens the slider with more images.
 */
function FaultImage({ files, opacity }: { files?: { fileId: string }[]; opacity: number }) {
  const [openedSlider, setOpenSlider] = useState(false);

  const images = files || [];
  const firstImage = images.length > 0 ? images[0] : null;

  return firstImage ? (
    <Box p={8} w={60} h={60} miw={60} mih={60} mah={60} maw={60} style={{ opacity }}>
      <FileThumbnail fileId={firstImage.fileId} onOpenSlider={() => setOpenSlider(true)} />
      <Slider
        key={firstImage.fileId}
        opened={openedSlider}
        fileIds={images.map((image) => image.fileId)}
        onClose={() => setOpenSlider(false)}
        initialImageId={firstImage.fileId}
      />
    </Box>
  ) : (
    <Box w={60} h={60} miw={60} mih={60} mah={60} maw={60} />
  );
}

/**
 * Column for the fault name.
 */
export default function FaultNameColumn({ data: { faultName, fixed, files } }: { data: FaultRow }) {
  const opacity = fixed && fixed.fixedAt !== undefined ? 0.6 : 1;

  return (
    <Group noWrap spacing={8} align="center">
      {FEATURE_TOGGLE_DEVICE_IMAGES_SLIDER && <FaultImage files={files} opacity={opacity} />}
      {fixed && fixed.fixedAt !== undefined && <BadgeFixed text="Vyriešený" />}
      <P2Medium color="gray.8" style={{ opacity }}>
        <Excerpt text={faultName} length={100} />
      </P2Medium>
    </Group>
  );
}
